import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { ReactNode } from 'react';
import { LayoutBox } from './auto-layout';

interface Props {
  id: string;
  box: LayoutBox;
  disabled: boolean;
  children: ReactNode;
}

export function SortableTile({ id, box, disabled, children }: Props) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id, disabled });

  return (
    <div
      ref={setNodeRef}
      className={disabled ? 'absolute' : 'absolute cursor-grab'}
      style={{
        left: box.left,
        top: box.top,
        width: box.width,
        height: box.height,
        transform: CSS.Transform.toString(transform),
        transition,
        zIndex: isDragging ? 30 : undefined,
      }}
      {...attributes}
      {...listeners}
    >
      {children}
    </div>
  );
}

export default SortableTile;
